import { useLocation } from 'wouter';

export const Footer = () => {
    const [, setLocation] = useLocation();
    const go = (p: string) => setLocation(p);
    const link = "block text-left text-[#d9d4e4] text-sm py-1.5 hover:text-white transition-colors";

    return (
        <footer className="bg-ink text-white border-t-2 border-ink">
            <div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
                <div className="col-span-2 md:col-span-1">
                    <div className="font-display font-black text-2xl text-white tracking-wide">ANOKOE</div>
                    <p className="text-[#c9c2d6] text-sm mt-3 max-w-[260px] leading-relaxed">
                        テキスト・絵・声。三位一体で物語を紡ぐ、共創プラットフォーム。
                    </p>
                </div>
                <div>
                    <h5 className="font-display font-bold text-sm text-sun mb-3 tracking-wide">さがす</h5>
                    <button className={link} onClick={() => go('/ranking')}>ランキング</button>
                    <button className={link} onClick={() => go('/')}>起点の作品</button>
                    <button className={link} onClick={() => { go('/'); setTimeout(() => document.getElementById('themes')?.scrollIntoView({ behavior: 'smooth' }), 100); }}>共創ツリー</button>
                </div>
                <div>
                    <h5 className="font-display font-bold text-sm text-sun mb-3 tracking-wide">つくる</h5>
                    <button className={link} onClick={() => go('/')}>新しい物語</button>
                    <button className={link} onClick={() => go('/mypage')}>マイページ</button>
                </div>
                <div>
                    <h5 className="font-display font-bold text-sm text-sun mb-3 tracking-wide">ANOKOEについて</h5>
                    <button className={link} onClick={() => go('/')}>コンセプト</button>
                    <button className={link} onClick={() => go('/guidelines')}>ガイドライン</button>
                </div>
            </div>
            <div className="border-t border-white/15 text-center text-[#9890ab] text-xs py-4">
                © 2026 ANOKOE
            </div>
        </footer>
    );
};
